import {randomStringId} from "./randomId.ts"

export const tabId = randomStringId()
